import Spinner from "./Spinner";

export default function ChartPreloader(){
    return <span className="select-none text-black dark:text-white">
        <Spinner/>
    </span>
}